module.exports = __webpack_public_path__ + "static/recruit_image1-d7f061236b33366c8578d9c7e4186fb5.jpg";